import Highcharts from 'highcharts';
import { filterByCategory } from '../ranking-sm/data.js';

function getPouczeniaMandaty() {
    const data = filterByCategory(['Mandaty: liczba wystawionych', 'Pouczenia: liczba', 'Liczba mieszkańców'])

    const validData = data.filter(sm =>
        sm['Mandaty: liczba wystawionych'] &&
        sm['Pouczenia: liczba'] &&
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Pouczenia: liczba'] === 'number'
    )

    validData.forEach(sm => {
        sm.mandatyNaPouczenie = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Pouczenia: liczba']) * 100) / 100
        sm.pouczenieNaMandaty = Math.round((sm['Pouczenia: liczba'] / sm['Mandaty: liczba wystawionych']) * 100) / 100
        sm.mandatyNaPouczenia = Math.round(10 / sm.pouczenieNaMandaty) / 10
        sm.mandatyPer100k = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Liczba mieszkańców']) * 100000)
        sm.pouczeniaPer100k = Math.round((sm['Pouczenia: liczba'] / sm['Liczba mieszkańców']) * 100000)
        sm.lacznie = sm['Mandaty: liczba wystawionych'] + sm['Pouczenia: liczba']
        sm.procentPouczen = Math.round((sm['Pouczenia: liczba'] / sm.lacznie) * 100)
    })

    return validData.sort((a, b) => b.mandatyNaPouczenia - a.mandatyNaPouczenia)
}

export default function chartPouczenia(id) {
    if (!document.getElementById(id)) return;

    const data = getPouczeniaMandaty();

    const chartData = data.map(sm => ({
        name: sm.city,
        y: sm.mandatyNaPouczenia,
        mandaty: sm['Mandaty: liczba wystawionych'],
        pouczenia: sm['Pouczenia: liczba'],
        procentPouczen: sm.procentPouczen
    }));

    Highcharts.chart(id, {
        chart: { type: 'column', height: 600 },
        title: {
            text: 'Fines to warnings ratio',
            style: { fontSize: '18px', fontWeight: 'bold' }
        },
        subtitle: {
            text: 'Fines per warning (higher values = fewer warnings)'
        },
        xAxis: {
            categories: chartData.map(item => item.name),
            labels: { rotation: -45, style: { fontSize: '11px' } }
        },
        yAxis: {
            title: { text: 'Fines per warning' },
            min: 0
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    format: '{y}',
                    style: { fontSize: '10px' }
                },
                colorByPoint: true
            }
        },
        tooltip: {
            pointFormat: '<b>{point.name}</b><br/>Fines per warning: <b>{point.y}</b>'
        },
        series: [{
            type: 'column',
            name: 'Fines per warning',
            data: chartData,
            showInLegend: false
        }],
        credits: { enabled: false }
    });
}
